module.exports = __webpack_public_path__ + "static/media/down_arrow.1b72ddcf.svg";